var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'lodash';
import EntityUtil from 'gw-portals-util-js/EntityUtil';

var WCClaimExtension = function () {
    function WCClaimExtension(_claim) {
        _classCallCheck(this, WCClaimExtension);

        Object.defineProperty(this, '_claim', {
            enumerable: false,
            value: _claim
        });

        var workersComp = this._claim.lobs.workersComp;

        this.dateReportedToEmployer = workersComp && workersComp.dateReportedToEmployer ? workersComp.dateReportedToEmployer : null;

        this.incidentReport = workersComp && _.isBoolean(workersComp.incidentReport) ? workersComp.incidentReport : false;
        this.deathReport = workersComp && _.isBoolean(workersComp.deathReport) ? workersComp.deathReport : null;
        this.timeLossReport = workersComp && _.isBoolean(workersComp.timeLossReport) ? workersComp.timeLossReport : null;
        this.employmentInjury = workersComp && _.isBoolean(workersComp.employmentInjury) ? workersComp.employmentInjury : null;
        this.medicalReport = workersComp && _.isBoolean(workersComp.medicalReport) ? workersComp.medicalReport : null;
        this.firstIntakeDoctor = workersComp && workersComp.firstIntakeDoctor ? workersComp.firstIntakeDoctor : null;

        this.examinationDate = workersComp && workersComp.examinationDate ? workersComp.examinationDate : null;

        this.injuryIncident = workersComp && workersComp.injuryIncident ? workersComp.injuryIncident : {
            injured: null,
            description: null,
            generalInjuryType: 'specific',
            detailedInjuryType: null,
            bodyParts: null
        };

        this.injuryIncident.bodyParts = workersComp && workersComp.injuryIncident && workersComp.injuryIncident.bodyParts ? workersComp.injuryIncident.bodyParts : [];

        this.availableContacts = [];
    }

    _createClass(WCClaimExtension, [{
        key: 'getAvailableContacts',
        value: function getAvailableContacts() {
            return this.availableContacts.slice(0);
        }
    }, {
        key: 'addBodyPartDetails',
        value: function addBodyPartDetails() {
            this._claim.lobs.workersComp.injuryIncident.bodyParts.push({
                tempID: EntityUtil.nextId(),
                primaryBodyPart: null,
                detailedBodyPart: null,
                detailedBodyPartDesc: null,
                sideOfBody: null,
                impairmentPercentage: null
            });
        }
    }, {
        key: 'removeBodyPartDetails',
        value: function removeBodyPartDetails(bodyPartToRemove) {
            var indexToRemove = this._claim.lobs.workersComp.injuryIncident.bodyParts.findIndex(function (exist) {
                var tempIDMatches = bodyPartToRemove.tempID && exist.tempID === bodyPartToRemove.tempID;
                var publicIDMatches = bodyPartToRemove.publicID && exist.publicID === bodyPartToRemove.publicID;
                return tempIDMatches || publicIDMatches;
            });
            if (indexToRemove !== -1) {
                this._claim.lobs.workersComp.injuryIncident.bodyParts.splice(indexToRemove, 1);
            }
        }
    }]);

    return WCClaimExtension;
}();

export default WCClaimExtension;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/wc/models/WCClaimExtension.js
// module id = 1603
// module chunks = 0